export { default } from './avatar';
